export function hide() {
  // Xóa class "active" cho các li.active
  document.querySelectorAll(".option-content li.active").forEach((el) => {
    el.classList.remove("active");
  });

  // Xóa class "active" cho các li.style
  document.querySelectorAll(".option-content li.style").forEach((el) => {
    el.classList.remove("active");
  });

  // Xóa class "active" cho #productTab và #logoTab
  document.getElementById("productTab")?.classList.remove("active");
  document.getElementById("logoTab")?.classList.remove("active");
}

export function tabClick(ele) {
  // Lấy giá trị của thuộc tính alt từ phần tử được click
  const src = ele.getAttribute("alt");

  // Lấy phần tử cha
  const parent = ele.parentElement;

  // Lấy class của phần tử cha
  const classActive = parent.getAttribute("class");

  if (classActive && classActive.includes("active")) {
    // Xóa class active ở tất cả li trong option-content và option-list
    document.querySelectorAll(".option-content li.active").forEach((el) => {
      el.classList.remove("active");
    });

    document.querySelectorAll(".option-list li.active").forEach((el) => {
      el.classList.remove("active");
    });
  } else {
    // Xóa class active ở tất cả li trong option-content và option-list
    document.querySelectorAll(".option-content li.active").forEach((el) => {
      el.classList.remove("active");
    });

    document.querySelectorAll(".option-list li.active").forEach((el) => {
      el.classList.remove("active");
    });

    // Thêm class active cho phần tử cha của ele
    parent.classList.add("active");

    console.log(src);

    // Thêm class active cho phần tử li tương ứng trong option-content
    const target = document.querySelector(`.option-content li.${src}`);
    if (target) target.classList.add("active");
  }
}

export function productClick() {
  const productTab = document.getElementById("productTab");

  if (productTab.classList.contains("active")) {
    productTab.classList.remove("active");
    hide();
  } else {
    hide();
    // Active product
    document.querySelectorAll(".option-content li.style").forEach((el) => {
      el.classList.add("active");
    });

    productTab.classList.add("active");
  }
}

export function logoClick() {
  console.log("logo click");

  const logoTab = document.getElementById("logoTab");

  if (logoTab.classList.contains("active")) {
    hide();
  } else {
    hide();
    // Active logo
    document.querySelectorAll(".option-content li.logo").forEach((el) => {
      el.classList.add("active");
    });

    logoTab.classList.add("active");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 700) {
    console.log("Is PC");
    document.querySelector(".option-content li.logo")?.classList.add("active");
    document.getElementById("logoTab")?.classList.add("active");
  } else {
    console.log("Is Mobile");
    hide();
  }
});
